import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './Pages/Home';
import { SelectedPlaylistView } from './Pages/SelectedPlaylist';
import { useState, useEffect, useCallback } from 'react';
import { initializeApp } from 'firebase/app';
import { getFirestore } from "firebase/firestore";
import axios from 'axios';
import Callback from './Pages/Callback';

const firebaseConfig = {
   apiKey: process.env.REACT_APP_FIREBASE_CONFIG_API_KEY,
   authDomain: process.env.REACT_APP_FIREBASE_CONFIG_AUTH_DOMAIN,
   projectId: process.env.REACT_APP_FIREBASE_CONFIG_PROJECT_ID,
   storageBucket: process.env.REACT_APP_FIREBASE_CONFIG_STORAGE_BUCKET,
   messagingSenderId: process.env.REACT_APP_FIREBASE_CONFIG_MESSAGING_SENDER_ID,
   appId: process.env.REACT_APP_FIREBASE_CONFIG_APP_ID,
   measurementId: process.env.REACT_APP_FIREBASE_CONFIG_MEASUREMENT_ID
};

export const CLIENT_ID = process.env.REACT_APP_SPOTIFY_CLIENT_ID
export const REDIRECT_URI = process.env.REACT_APP_SPOTIFY_REDIRECT_URI ?? ""
export const AUTH_ENDPOINT = process.env.REACT_APP_SPOTIFY_AUTH_ENDPOINT
export const RESPONSE_TYPE = process.env.REACT_APP_SPOTIFY_RESPONSE_TYPE

// Initialize Firebase
const fire_app = initializeApp(firebaseConfig);


// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(fire_app);


const App = () => {

   const [loggedInUser, setLoggedInUser] = useState("");
   const [token, setToken] = useState("")
   let location = useLocation()

   useEffect(() => {
      if (location.pathname !== "/callback") {
         window.localStorage.setItem("callbackRoute", location.pathname)
      }
   }, [location])

   const fetchCurrentUserID = useCallback(async (): Promise<string> => {
      const user_resp: any = await axios.get(`https://api.spotify.com/v1/me`, {
         headers: {
            Authorization: `Bearer ${token}`
         },
      }).catch(function (error) {
         return "" // TODO: do more with failure state
      })

      if (user_resp !== undefined && user_resp !== null && user_resp !== "") {
         setLoggedInUser(user_resp.data.id)
         window.localStorage.setItem("loggedInUser", user_resp.data.id); // set logged in user ID for access on other routes
         return user_resp.data.id
      } else {
         return ""
      }
   }, [token])

   useEffect(() => {
      const hash = window.location.hash;
      let access_token = window.localStorage.getItem("token");

      if (hash && hash) {
         access_token = hash.substring(1)?.split("&")?.find(elem => elem.startsWith("access_token"))?.split("=")[1] ?? null;
         if (access_token == null) {
            return
         }
         window.location.hash = "";
         window.localStorage.setItem("token", access_token);
      }

      if (access_token == null) {
         return
      }

      setToken(access_token)
      if (token !== "") {
         fetchCurrentUserID()
      }
   }, [token, fetchCurrentUserID])

   function appHeader() {

      const logout = () => {
         setToken("");
         window.localStorage.removeItem("token");
         window.localStorage.removeItem("loggedInUser");
         setLoggedInUser("");
      }

      function logInOutButton() {
         if (loggedInUser === "") {
            return (
               <a className="Login-button-link" href={`${AUTH_ENDPOINT}?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=${RESPONSE_TYPE}`}>
                  <div className="Login-button">Login to Spotify</div>
               </a>
            )
         } else {
            return (
               <div className="Login-button" onClick={logout}>Log out of Spotify</div>
            )
         }
      }

      return (
         <header className='App-header'>
            <p><span style={{ "fontSize": "80px", "fontFamily": "serif" }}>a</span>nnotatify</p>
            <a href='https://ko-fi.com/I3I1C79UF' target='_blank' rel='noreferrer'>
               <img
                  height='20'
                  className="Kofi-button"
                  src='https://storage.ko-fi.com/cdn/kofi4.png?v=6'
                  alt='Buy Me a Coffee at ko-fi.com' />
            </a>
            {logInOutButton()}
         </header>
      )
   }

   function appFooter() {
      return (
         <footer className='App-footer'>
            <span>Built by <a className="footer-link" href="https://bhargavannigeri.com">Bhargav Annigeri</a></span>
         </footer>
      )
   }

   return (
      <>
         {appHeader()}
         <Routes>
            <Route path="/" element={<Home token={token} />} />
            <Route path="/playlist/:playlistId" element={<SelectedPlaylistView />} />
            <Route path="/callback" element={<Callback />} />
         </Routes>
         {appFooter()}
      </>
   );
};

export default App;
